type OutfitSliderInput = {
  hasOutfitProducts: boolean;
  hasStructuredProductCards: boolean;
  isOutfitBuilding?: boolean;
  isProductSearching?: boolean;
  searchedProducts?: boolean;
};

// Hjärnan skickar med hela garderoben på VARJE tur, inte bara på outfit-turer —
// garderobspanelen lever på det. Utan grinden nedan kapar förra turens outfit
// svaret på nästa produktsökning: texten säger "här är sneakers" medan slidern
// visar gårdagens kavaj, och sneakerskorten renderas aldrig.
export const shouldShowOutfitSlider = ({
  hasOutfitProducts,
  hasStructuredProductCards,
  isOutfitBuilding,
  isProductSearching,
  searchedProducts,
}: OutfitSliderInput): boolean => {
  if (isOutfitBuilding) return true;
  if (!hasOutfitProducts) return false;
  return !hasStructuredProductCards && !isProductSearching && !searchedProducts;
};
